var map = {
	"./bao-cao/baocao.module.ngfactory": [
		"T5RB",
		1,
		4,
		0,
		12
	],
	"./client-template/client-template.module.ngfactory": [
		"KQNO",
		1,
		0,
		10
	],
	"./dapfood/dapfood.module.ngfactory": [
		"FLq1",
		1,
		3,
		4,
		5,
		0,
		11
	],
	"./error/error.module.ngfactory": [
		"NzVj",
		13
	],
	"./user/user.module.ngfactory": [
		"nX7e",
		1,
		3,
		0,
		14
	],
	"./work/work.module.ngfactory": [
		"wpiJ",
		1,
		3,
		4,
		5,
		0,
		15
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "crnd";
module.exports = webpackAsyncContext;